var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospitalBedIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_3839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 14.898L5.23066 12.6715C5.23066 12.6709 5.23066 12.6709 5.23066 12.6709C3.95045 11.6523 2.06273 12.3734 1.75781 13.9465V10.6055C1.75781 10.1203 1.36406 9.72656 0.878906 9.72656C0.39375 9.72656 0 10.1203 0 10.6055V20.2734C0 20.7586 0.39375 21.1523 0.878906 21.1523H8.02734C8.02734 20.4375 8.02734 15.641 8.02734 14.898ZM1.75781 19.3945V14.7838C1.85566 15.2789 2.12578 15.7418 2.55586 16.0758L6.62695 19.2316C6.73008 19.3113 6.84902 19.367 6.975 19.3945H1.75781Z",
    fill: "url(#paint0_linear_1236_3839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 13.2422C28.6359 13.2422 28.2422 13.6359 28.2422 14.1211V15.8789H26.543V21.1523H29.1211C29.6063 21.1523 30 20.7586 30 20.2734V14.1211C30 13.6359 29.6063 13.2422 29.1211 13.2422Z",
    fill: "url(#paint1_linear_1236_3839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6055 24.7266C24.4597 24.7266 23.4827 25.4614 23.1199 26.4844H17.6953V24.668H12.4219V26.4844H6.99727C6.63445 25.4614 5.65752 24.7266 4.51172 24.7266C3.05783 24.7266 1.875 25.9094 1.875 27.3633C1.875 28.8172 3.05783 30 4.51172 30C5.65752 30 6.63445 29.2652 6.99727 28.2422H23.1199C23.4827 29.2652 24.4597 30 25.6055 30C27.0594 30 28.2422 28.8172 28.2422 27.3633C28.2422 25.9094 27.0594 24.7266 25.6055 24.7266ZM4.51172 28.2422C4.02709 28.2422 3.63281 27.8479 3.63281 27.3633C3.63281 26.8787 4.02709 26.4844 4.51172 26.4844C4.99635 26.4844 5.39062 26.8787 5.39062 27.3633C5.39062 27.8479 4.99635 28.2422 4.51172 28.2422ZM25.6055 28.2422C25.1208 28.2422 24.7266 27.8479 24.7266 27.3633C24.7266 26.8787 25.1208 26.4844 25.6055 26.4844C26.0901 26.4844 26.4844 26.8787 26.4844 27.3633C26.4844 27.8479 26.0901 28.2422 25.6055 28.2422Z",
    fill: "url(#paint2_linear_1236_3839)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26956 9.72656H7.14847V9.76031C7.14847 10.2336 7.51216 10.6408 7.98489 10.6631C8.48962 10.6869 8.90628 10.2847 8.90628 9.78516V9.72656H9.78519C10.2706 9.72656 10.6641 9.33305 10.6641 8.84766V4.45312C10.6641 3.96773 10.2706 3.57422 9.78519 3.57422H8.90628V1.75781H12.4219V15.8789H9.78519V22.0312C9.78519 22.5166 10.1787 22.9102 10.6641 22.9102H23.9063C24.3917 22.9102 24.7852 22.5166 24.7852 22.0312V15.8789H14.1797V1.75781H16.7914C17.2645 1.75781 17.6717 1.39447 17.6943 0.921973C17.7184 0.417246 17.3159 0 16.8164 0H6.29458C5.8215 0 5.41427 0.363281 5.39165 0.83584C5.36757 1.34057 5.77011 1.75781 6.26956 1.75781H7.14847V3.57422H6.26956C5.78417 3.57422 5.39066 3.96773 5.39066 4.45312V8.84766C5.39066 9.33305 5.78417 9.72656 6.26956 9.72656Z",
    fill: "url(#paint3_linear_1236_3839)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_3839",
    x1: 0.112057,
    y1: 18.8672,
    x2: 8.02734,
    y2: 18.8672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1236_3839",
    x1: 26.5912,
    y1: 19.5703,
    x2: 30,
    y2: 19.5703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1236_3839",
    x1: 2.24307,
    y1: 28.9336,
    x2: 28.2422,
    y2: 28.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1236_3839",
    x1: 5.66136,
    y1: 18.3281,
    x2: 24.7852,
    y2: 18.3281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_3839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBedIc);
export default __webpack_public_path__ + "static/media/hospital-bed_ic.7ecc096f7b8c196d364253fb16c46b9b.svg";
export { ForwardRef as ReactComponent };